import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '../../../../tool'

import { templateConfig, reduxTemplateConfig } from './config'

let { WizContainer, WizReduxTemplate, modelUtils } = framework_tool
let { WizBrowserExport } = component_tool
const { Session } = utils_tool

const _getValue = (type, key) => {
  const values = {
    userType: {
      0: '培训平台用户',
      3: 'OEM部门用户',
      4: '经销商用户',
      5: '服务商用户'
    },
  }
  return values[type][key]
}
class InvitationManager extends WizContainer {
  componentName = 'invitationManager'

  constructor(props) {
    super(props)
    const { history } = props
    let detailInfo = {}
    let topic = {}
    if (history.location) {
      if (history.location.pathname === '/interact/community/invitation/invitationTranspond') {
        if (history.location && history.location.record) {
          detailInfo = history.location.record
          Session.set('detailInfo', detailInfo)
        } else {
          detailInfo = Session.get('detailInfo') || {}
        }
      } else if (history.location.pathname === '/community/topic/invitation') {
        if (history.location && history.location.record) {
          topic = history.location.record
          Session.set('topic_invitation', topic)
        } else {
          topic = Session.get('topic_invitation') || {}
        }
      }
    }
    this.detailInfo = detailInfo
    this.state = {
      topic
    }
  }

  _componentDidMount() {
    if (this.detailInfo && this.detailInfo.searchProps && this.detailInfo.searchProps.invitation) {
      let invitation = this.detailInfo.searchProps.invitation
      this.doAction({
        path: 'invitation/listByPage',
        payload: {
          key: 'invitation@listByPage',
          apiParams: {
            transferId: invitation.id
          }
        },
      })
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true
    } else {
      wizNotice.error(o['msg'])
      return false
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '用户昵称',
        field: 'nickName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '证件号码',
        field: 'idCard',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '手机号',
        field: 'mobile',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '用户属性',
        field: 'userType',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '账号状态',
        field: 'disabled',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '所属话题',
        field: 'topicName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '帖子内容',
        field: 'content',
        width: 50,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '帖子类型',
        field: 'type',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '帖子来源',
        field: 'sourceType',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '点赞量',
        field: 'agreeCount',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '点踩量',
        field: 'stepCount',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '转发量',
        field: 'transpondCount',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '评论量',
        field: 'commentCount',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '发帖时间',
        field: 'createTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if (o['success']) {
      let data = o['data']
      data && data.forEach(e => {
        e['userType'] = _getValue('userType',e['userType'])
        e['disabled'] == 0 ? e['disabled'] = '激活' : e['disabled'] = '禁用'
        e['type'] == 0 ? e['type'] = '文本' : e['type'] == 1 ? e['type'] = '图片' : e['type'] = '视频'
        e['sourceType'] == 0 ? e['sourceType'] = '原创' : e['sourceType'] == 1 ? e['sourceType'] = '转发' : e['sourceType'] = '分享'
      })
      WizBrowserExport({
        title: '帖子信息',
        sheetName: '帖子信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '帖子信息.xlsx',
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false
    }
  }

  _render() {
    let defaultParams = {}
    let btnAccessCheck = true
    if (this.detailInfo && this.detailInfo.searchProps && this.detailInfo.searchProps.invitation) {
      defaultParams.transferId = this.detailInfo.searchProps.invitation.id
      defaultParams.transfer = this.detailInfo.searchProps.invitation
      btnAccessCheck = false
    }

    let { topic } = this.state
    if (topic && topic.id) {
      defaultParams.topicId = topic.id
      btnAccessCheck = false
    }

    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: templateConfig({ jumpPage: this.jumpPage, btnAccessCheck, topic,defaultParams }),
      apiDataFormat: {
        add: this._handleCMD,
        delete: this._handleCMD,
        export: this._handleFile,
        popularEnable: this._handleCMD,
        topicEnable: this._handleCMD,
      },
      defaultParams
    })
    return <WizReduxTemplate {..._reduxTemplateConfig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  const { invitation } = state
  const invitationList = modelUtils.getModelEntity(invitation, 'invitation@listByPage')
  const load = modelUtils.getLoadingState(state, 'invitation')
  return {
    invitationList: invitationList,
    ...load
  }
}

export default connect(mapStateToProps)(InvitationManager)

